// extracted by mini-css-extract-plugin
export default {"totalPrice":"uiuIw","withSeatingPlan":"AoCBa","totalPriceRow":"rwwn9"};